module.exports = __webpack_public_path__ + "img/psd3.5c871e9e.png";